import image1 from "../Images/HTML.CSS.JPG";
import image2 from "../Images/HTML.CSS2.png";
import image3 from "../Images/HTML.CSS.JavaScript.png";
import image4 from "../Images/HTML.CSS.JavaScript2.png";
import image5 from "../Images/HTML.CSS.JavaScript3.png";
import image6 from "../Images/e-commerce.png";
import image7 from "../Images/movie.png";
import image8 from "../Images/e-prime.JPG";
import "../CSS/Cards.css";
import Navbar from "./Header";
function Cards() {
  return (
    <div className="cards">
      <Navbar />
      <div className="text">
        <h3>My Projects</h3>
      </div>
      <div className="cards-container">
        <div className="card7">
          <img
            src={image7}
            alt=""
            onClick={() => {
              window.open("https://ahmedelabher.github.io/movies/", "_blank");
            }}
          ></img>
          <p>Created By "React JS"</p>
        </div>
        <div className="card8">
          <img
            src={image8}
            alt=""
            onClick={() => {
              window.open("https://ahmedelabher.github.io/e-prime/", "_blank");
            }}
          ></img>
          <p>Created By "React JS"</p>
        </div>
        <div className="card6">
          <img
            src={image6}
            alt=""
            onClick={() => {
              window.open(
                "https://ahmedelabher.github.io/e-commerce/",
                "_blank"
              );
            }}
          ></img>
          <p>Created By "React JS"</p>
        </div>
        <div className="card1">
          <img
            src={image1}
            alt=""
            onClick={() => {
              window.open(
                "https://ahmedelabher.github.io/Project-one/",
                "_blank"
              );
            }}
          ></img>
          <p>Created By " HTML & CSS "</p>
        </div>
        <div className="card2">
          <img
            src={image2}
            alt=""
            onClick={() => {
              window.open("https://ahmedelabher.github.io/Kasper/", "_blank");
            }}
          ></img>
          <p>Created By " HTML & CSS "</p>
        </div>
        <div className="card3">
          <img
            src={image3}
            alt=""
            onClick={() => {
              window.open("https://ahmedelabher.github.io/Coffee/", "_blank");
            }}
          ></img>
          <p>Created By " HTML, CSS & JavaScript "</p>
        </div>
        <div className="card4">
          <img
            src={image4}
            alt=""
            onClick={() => {
              window.open(
                "https://ahmedelabher.github.io/Creative-Land/",
                "_blank"
              );
            }}
          ></img>
          <p>Created By " HTML, CSS & JavaScript "</p>
        </div>
        <div className="card5">
          <img
            src={image5}
            alt=""
            onClick={() => {
              window.open(
                "https://ahmedelabher.github.io/HTML-CSS-Java-Script---Project/",
                "_blank"
              );
            }}
          ></img>
          <p>Created By " HTML, CSS & JavaScript "</p>
        </div>
      </div>
    </div>
  );
}
export default Cards;
